import { ReactNode } from 'react';
import {
  Checkbox as StyledCheckbox,
  StyledIconTick,
  Label,
  CheckboxWrapper,
} from './Checkbox.styles';

export interface CheckboxProps {
  checked: boolean;
  onToggle: (newCheckedValue: boolean) => void;
  label?: ReactNode;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
  justifyContent?: string;
}

export const Checkbox = ({
  checked,
  onToggle,
  label,
  className,
  ariaLabel,
  disabled,
  justifyContent,
  ...rest
}: CheckboxProps) => (
  <CheckboxWrapper
    className={className}
    justifyContent={justifyContent}
    onClick={() => onToggle(!checked)}
    {...rest}
  >
    <StyledCheckbox aria-label={ariaLabel} checked={checked} type="button" disabled={disabled}>
      {checked && <StyledIconTick />}
    </StyledCheckbox>
    {label && <Label>{label}</Label>}
  </CheckboxWrapper>
);
